import React from 'react';
import commingSoon from '../.././images/commingSoon.jpg';
const Pay = () => {
    return (
        <div>
<h2 className="  AddServiceHeader p-3  mx-auto mt-1"> Payment</h2>       
     <img src={commingSoon} alt="" className="w-50"/>
        </div>
    );
};

export default Pay;